const WORKSTORY_LOGO_WHITE_PATH = 'workstory-logo_white.png';

const WORKSTORY_LOGO_BLACK_PATH = 'workstory-logo_black.png';

const COMPANY_IMAGES_PATH = 'companyImages';

const BUILDER_REPORT_BATCH_PATH = 'builderReportBatch';

const COMPANY_LOGOS_PATH = `${COMPANY_IMAGES_PATH}/logos`;

const ROLES = {
  GENERAL: 'General'
};

const MAX_ITEMS_PER_REQUEST = 15;

const SHOW_INTRO = {
  ORGANIZATION: 'organization_intro', // show the organization page intro
  DASH: 'dash_intro', // show the dash page intro
  USER_PROFILE: 'user_profile_intro',
  DONE: 'done' // do not show any intro
};

const SHOW_INTRO_DEFAULT_SETTING = {
  [SHOW_INTRO.ORGANIZATION]: false,
  [SHOW_INTRO.DASH]: false,
  [SHOW_INTRO.USER_PROFILE]: false
};

const EDIT_MODES = {
  ADD: 'add',
  EDIT: 'edit'
};

const SHOW_INTRO_DEFAULT_SETTING_ADMIN = { ...SHOW_INTRO_DEFAULT_SETTING };
SHOW_INTRO_DEFAULT_SETTING_ADMIN[SHOW_INTRO.ORGANIZATION] = true;
SHOW_INTRO_DEFAULT_SETTING_ADMIN[SHOW_INTRO.DASH] = true;

const SHOW_INTRO_DEFAULT_SETTING_INVITED_USER = {
  ...SHOW_INTRO_DEFAULT_SETTING
};
SHOW_INTRO_DEFAULT_SETTING_INVITED_USER[SHOW_INTRO.DASH] = true;

const SLACK_REDIRECT_URI = {
  USER_SETTINGS: '/dashboard/settings',
  DASHBOARD: '/dashboard/',
  DASHBOARD_INTRO_2: '/dashboard/intro/2',
  ONBOARDING: '/dashboard/get-started/',
  ONBOARDING_COMPLETE: '/dashboard/onboarding/complete'
};

const LOGIN_TYPES = {
  SPEEDBACK: 'Speedback',
  SPEEDBACK_INVITED: 'SpeedbackInvitedUser',
  GOOGLE: 'Google'
};

const COMMUNICATION_TYPES = {
  EMAIL: 'email',
  SLACK: 'slack',
  GOOGLE_CHAT: 'google-chat',
  MS_TEAMS: 'msteams',
  WEBEX: 'webex'
};

const INTERACTION_SOURCE = {
  EMAIL: COMMUNICATION_TYPES.EMAIL,
  WEBSITE: 'website',
  SLACK: COMMUNICATION_TYPES.SLACK,
  GOOGLE_CHAT: COMMUNICATION_TYPES.GOOGLE_CHAT,
  MS_TEAMS: COMMUNICATION_TYPES.MS_TEAMS,
  WEBEX: COMMUNICATION_TYPES.WEBEX
};

const DATE_FILTERS = {
  PAST_THREE_MONTHS: 'Past 3 Months',
  PAST_SIX_MONTHS: 'Past 6 Months',
  PAST_MONTH: 'Past Month',
  PAST_YEAR: 'Past Year'
};

const REPORT_SHARE_PERMISSIONS = {
  canView: true,
  canAddNotes: false
};

const REPORT_TYPE = {
  PERFORMANCE_EVALUATION: 'Performance Evaluation',
  DYNAMIC: 'Dynamic',
  SELF_REVIEW: 'Self Review',
  REVIEW: 'Review'
};

const REPORT_NOTE_TYPES = {
  FEEDBACK: 'Feedback Note',
  CATEGORY: 'Category Note',
  SUMMARY: 'Summary Note',
  GOAL: 'Goal Note'
};

const REVIEW_SCHEDULING_TIME = {
  ANYTIME: 'Anytime',
  TEN_TO_FIVE: '10am to 5pm',
  EIGHT_TO_FIVE: '8am to 5pm',
  EIGHTAM_NINEAM: '8am to 9am',
  DYNAMIC: 'Dynamic',
  CUSTOM: 'custom',
  COMPANY_DEFAULT: 'company_default'
};

const SCHEDULE_TIMES = {
  GENERAL: {
    DAYS: [1, 2, 3, 4, 5],
    HOURS: {
      start: 8,
      end: 17
    }
  },
  [REVIEW_SCHEDULING_TIME.TEN_TO_FIVE]: {
    DAYS: [1, 2, 3, 4, 5],
    HOURS: {
      start: 10,
      end: 17
    }
  },
  [REVIEW_SCHEDULING_TIME.EIGHT_TO_FIVE]: {
    DAYS: [1, 2, 3, 4, 5],
    HOURS: {
      start: 8,
      end: 17
    }
  },
  [REVIEW_SCHEDULING_TIME.EIGHTAM_NINEAM]: {
    DAYS: [1, 2, 3, 4, 5],
    HOURS: {
      start: 8,
      end: 9
    }
  }
};

const BILLING_PLANS = {
  FREE: 'Free',
  GROWTH: 'Growth'
};

const BILLING_FREQUENCY = {
  MONTHLY: 'Monthly',
  YEARLY: 'Yearly'
};

const ACCESS = {
  NONE: 'None',
  BASIC: 'Basic',
  MANAGER: 'Manager',
  ADMIN: 'Admin'
};

const REVIEW_ANSWER_TYPE = {
  NOT_AVAIL: 'N/A',
  NUMERIC: 'Numeric',
  FREE_TEXT: 'Free Text'
};

const REVIEW_STATUS = {
  SCHEDULED: 'Scheduled',
  SENT: 'Sent',
  REVIEWED: 'Reviewed',
  IN_PROGRESS: 'In Progress', // to be deprecated? or unsure?
  DELIVERY_FAILED: 'Delivery Failed',
  FAILED: 'Failed',
  EXPIRED: 'Expired',
  NOT_AVAIL: 'N/A'
};

const REPORT_STATUS = {
  IN_PROGRESS: 'In Progress',
  FINISHED: 'Finished'
};

const BUILDER_REPORT_STATUS = {
  DRAFT: 'Draft',
  COMPLETE: 'Complete'
};

const BUILDER_REVIEW_MODE = {
  CATEGORIES: 'categories',
  QUESTIONS: 'questions'
};

const BUILDER_COMPANY_MODE = {
  COMPANY: 'company',
  PUBLIC: 'public'
};

const TIMES_IN_SECONDS = {
  THREE_MONTHS: 7257600,
  ONE_WEEK: 604800,
  TEN_DAYS: 864000,
  ONE_DAY: 86400
};

// textForm is used when building the review question text
const EMAIL_FREQUENCY = {
  BIWEEKLY: {
    // twice per week
    value: 'Biweekly',
    label: 'Twice per week',
    textForm: 'in the last week',
    seconds: 302400
  },
  WEEKLY: {
    value: 'Weekly',
    label: 'Every week',
    textForm: 'in the last week',
    seconds: 604800
  },
  EVERY_10_DAYS: {
    value: '10 days',
    label: 'Every 10 days',
    textForm: 'in the last 10 days',
    seconds: 864000
  },
  BIMONTHLY: {
    value: '2 weeks',
    label: 'Every 2 weeks',
    textForm: 'in the last 2 weeks',
    seconds: 1209600
  },
  EVERY_3_WEEKS: {
    value: '3 weeks',
    label: 'Every 3 weeks',
    textForm: 'in the last 3 weeks',
    seconds: 1814400
  },
  MONTHLY: {
    value: 'Monthly',
    label: 'Every month',
    textForm: 'in the last month',
    seconds: 2592000 // 30 days
  },
  EVERY_6_WEEKS: {
    value: '6 weeks',
    label: 'Every 6 weeks',
    textForm: 'in the last month',
    seconds: 604800 * 6
  },
  EVERY_8_WEEKS: {
    value: '8 weeks',
    label: 'Every 8 weeks',
    textForm: 'in the last 2 month',
    seconds: 604800 * 8
  },
  EVERY_QUARTER: {
    value: '12 weeks',
    label: 'Every quarter',
    textForm: 'in the last quarter',
    seconds: 604800 * 12
  }
  // ONCE_EVERY_TWO_MONTHS: {
  //   value: '2 Months',
  //   label: 'Every 2 months',
  //   seconds: 4838400,
  // },
};

const DATE_RANGE_FILTERS = {
  LAST_MONTH: {
    key: 'lastMonth',
    label: 'Last Month',
    longLabel: 'Last Month',
    wordedLabel: 'A month ago',
    timeLabel: '1 Month',
    days: 30
  },
  THREE_MONTHS: {
    key: '3months',
    label: '3 Months',
    longLabel: 'Last 3 months',
    wordedLabel: 'Three months ago',
    timeLabel: '3 Months',
    days: 91
  },
  SIX_MONTHS: {
    key: '6months',
    label: '6 Months',
    longLabel: 'Last 6 months',
    wordedLabel: 'Six months ago',
    timeLabel: '6 Months',
    days: 182
  },
  ONE_YEAR: {
    key: '1year',
    label: '1 Year',
    longLabel: 'Last 1 year',
    wordedLabel: 'A year ago',
    timeLabel: '1 Year',
    days: 365
  },
  ALL_TIME: {
    key: 'all',
    label: 'All Time',
    longLabel: 'All Time',
    wordedLabel: 'All Time',
    timeLabel: 'All Time',
    days: null
  },
  CUSTOM: {
    key: 'custom',
    label: 'Custom',
    longLabel: 'Custom',
    wordedLabel: 'Custom',
    timeLabel: 'Custom',
    days: null
  }
};

const REVIEW_FILTERS = {
  ALL_ABOVE: 'Filter by higher levels',
  MANAGER: 'Filter by manager',
  MANAGERS: 'Filter by managers',
  COWORKERS: 'Filter by coworkers',
  EMPLOYEES: 'Filter by employees',
  SELF: 'Filter by self',
  ALL_BUT_SELF: 'Filter all except self'
};

const EVENT_TYPES = {
  SUMMARY_EVENT: 'SUMMARY_EVENT',
  RANDOM_EVENT: 'RANDOM_EVENT',
  TRIAL_EXPIRES: 'TRIAL_EXPIRES',
  REVIEW: 'REVIEW_EVENT',
  PULSE: {
    PULSE_REVIEW: 'PULSE_REVIEW',
    PULSE_QUESTION: 'PULSE_QUESTION'
  },
  GOAL_UPDATE: 'GOAL_UPDATE'
};

const EVENT_LABELS = {
  SUMMARY_EVENT: 'Summary Events',
  RANDOM_EVENT: 'Random Events',
  TRIAL_EXPIRES: 'Trial Expires Events',
  REVIEW: 'Review Events',
  PULSE: {
    PULSE_REVIEW: 'Pulse Review Events',
    PULSE_QUESTION: 'Pulse Question Events'
  },
  GOAL_UPDATE: 'Goal Update Events'
};

const AFTER_REVIEW_TYPE = {
  POSITIVE: 'Positive',
  NEGATIVE: 'Negative'
};

const BLOG = {
  CATEGORIES: {
    GENERAL: '',
    REVIEWS: 'Reviews',
    FEEDBACK: 'Feedback',
    BEST_PRACTICES: 'Best Practices',
    CULTURE: 'Culture',
    TRANSPARENCY: 'Transparency',
    REVIEWS360: '360 Reviews'
  },
  TYPES: {
    KNOWLEDGE: 'Knowledge Library',
    BLOG: 'Blog'
  }
};

// maybe deprecated?
const TASK_EVENTS = {
  REVIEW: {
    name: 'REVIEW_EVENT',
    endpoint: '/job'
  },
  RANDOM_PERIOD_EVENT: {
    name: 'RANDOM_PERIOD_EVENT',
    endpoint: '/randomEvent'
  },
  TOGGLE_COMPANY_REVIEWS: {
    name: 'TOGGLE_COMPANY_REVIEWS',
    endpoint: '/toggleReviews'
  }
};

const EMAIL_TYPES = {
  CONNECT_SLACK_REMINDER: 'Connect-Slack-Reminder'
};
const PUBLIC_LH3_PROFILE_IMAGES_URL = 'https://lh3.googleusercontent.com/';
const PUBLIC_PROFILE_IMAGES_URL = 'https://storage.googleapis.com';
const PUBLIC_BUCKET_URL = `${PUBLIC_PROFILE_IMAGES_URL}/publicapeedback`;
const DEFAULT_TIMEZONE_OFFSET = -300; // (TO BE DEPRECATED) US/Canada Eastern -05:00 default timezone
const DEFAULT_TIMEZONE = 'America/New_York';

const SCORE_SYSTEM = {
  NPS: 'NPS',
  AVERAGE: 'Average',
  E_NPS: 'E_NPS'
};

const REVIEW_VISIBILITY = {
  VISIBLE_TO_MANAGER: 'VISIBLE_TO_MANAGER',
  ANONYMOUS: 'ANONYMOUS'
};

const COMMENT_VISIBILITY = {
  VISIBLE_TO_MANAGER: 'VISIBLE_TO_MANAGER',
  VISIBLE_TO_REVIEWEE: 'VISIBLE_TO_REVIEWEE'
};

const DIRECT_REVIEW_PERMISSIONS = {
  OPEN: 'OPEN', // can review everyone
  PER_REVIEW_RELATIONSHIPS: 'PER_REVIEW_RELATIONSHIPS'
};

const VIEW_USER_PROFILE_PERMISSIONS = {
  OPEN: 'OPEN', // can view all user profiles
  HIERARCHY: 'HIERARCHY' // user can view all profiles beneath them
};

const VIEW_SCORES_PERMISSIONS = {
  MANAGERS: 'MANAGERS',
  ALL: 'ALL'
};

const FEEDBACK_VISIBLE = {
  PUBLIC: 'Public', // Admin can see
  PRIVATE: 'Private', // Admin cannot see
  PRIVATE_AND_MANAGER: 'PrivateAndManager', // Admin can see
  MANAGER: 'Manager', // Admin can see
  MANAGER_AND_UP: 'ManagerAndUp', // Admin can see
  USER_AND_UP: 'UserAndUp', // Admin can see
  CUSTOM: 'Custom'
};

// Review comments visibility options
const SHARE_REVIEW_WITH = {
  OPEN_TO_EVERYONE: 'OPEN_TO_EVERYONE',
  OPENLY_WITH_REVIEWEE: 'OPENLY_WITH_REVIEWEE', // review comment and name visible to reviewer, users above and users that manage the reviewee
  REVIEWEE: 'WITH_REVIEWEE', // review comment is visible to all, reviewer name is visible only to manager (and admins)
  REVIEWEE_MANAGER: 'WITH_REVIEWEE_MANAGER', // review comment not visible to reviewee, but it is visible to manager and above. Name is visible to manager and above (and admins) in historic feedback table only.
  ANONYMOUS: 'ANONYMOUS' // review comment is visible to manager (and admins). reviewer name is anonymous to all.
};

const DEFAULT_REVIEW_COMMENT_VISIBILITY = SHARE_REVIEW_WITH.REVIEWEE_MANAGER;

const SHARE_REVIEW_WITH_DESCRIPTION = {
  OPEN_TO_EVERYONE: {
    value: 'OPEN_TO_EVERYONE',
    description: 'Share openly with team',
    shortDescription: 'Public and Open',
    subtitle:
      "Everyone in the organization can see your feedback and know it's from you."
  },
  OPENLY_WITH_REVIEWEE: {
    value: 'OPENLY_WITH_REVIEWEE',
    description: 'Share openly with @revieweeName',
    shortDescription: 'Open with Reviewee',
    subtitle:
      "Both the reviewee and their managers can see your feedback and know it's from you."
  },
  REVIEWEE: {
    value: 'WITH_REVIEWEE',
    description: 'Share your comment only',
    shortDescription: 'Anonymous to Reviewee',
    subtitle:
      "The reviewee sees your comment without knowing it's from you. Managers can see your name."
  },
  REVIEWEE_MANAGER: {
    value: 'WITH_REVIEWEE_MANAGER',
    description: "Share with @revieweeName's manager",
    shortDescription: 'Visible to Manager',
    subtitle:
      "Only the managers can see your feedback with your name. The reviewee won't know you provided feedback."
  },
  ANONYMOUS: {
    value: 'ANONYMOUS',
    description: 'Share anonymously',
    shortDescription: 'Anonymous to Manager',
    subtitle:
      "Only the managers see your comment without knowing it's from you."
  }
};

const renderShareCommentsVisibilityOptions = ({
  revieweeName = false,
  availableVisibilityOptions,
  isSlackTemplate,
  isAdaptiveCardTemplate
}) => {
  let name = 'reviewee';
  if (typeof revieweeName === 'string') {
    const names = revieweeName.trim().split(' ');
    let lastName = names.length > 1 ? names.pop() : '';
    const firstName = names.join(' ');

    if (lastName.length === 1) lastName = `${lastName}.`;
    name = `${firstName} ${lastName}`;
  }
  name = name.trim();
  const visibilityList = [
    {
      title: SHARE_REVIEW_WITH_DESCRIPTION.OPEN_TO_EVERYONE.description,
      value: SHARE_REVIEW_WITH_DESCRIPTION.OPEN_TO_EVERYONE.value,
      comments: SHARE_REVIEW_WITH_DESCRIPTION.OPEN_TO_EVERYONE.subtitle,
      shortDescription:
        SHARE_REVIEW_WITH_DESCRIPTION.OPEN_TO_EVERYONE.shortDescription
    },
    {
      title:
        SHARE_REVIEW_WITH_DESCRIPTION.OPENLY_WITH_REVIEWEE.description.replace(
          '@revieweeName',
          name
        ),
      value: SHARE_REVIEW_WITH_DESCRIPTION.OPENLY_WITH_REVIEWEE.value,
      comments: SHARE_REVIEW_WITH_DESCRIPTION.OPENLY_WITH_REVIEWEE.subtitle,
      shortDescription:
        SHARE_REVIEW_WITH_DESCRIPTION.OPENLY_WITH_REVIEWEE.shortDescription
    },
    {
      title: SHARE_REVIEW_WITH_DESCRIPTION.REVIEWEE.description,
      value: SHARE_REVIEW_WITH_DESCRIPTION.REVIEWEE.value,
      comments: SHARE_REVIEW_WITH_DESCRIPTION.REVIEWEE.subtitle,
      shortDescription: SHARE_REVIEW_WITH_DESCRIPTION.REVIEWEE.shortDescription
    },
    {
      title: SHARE_REVIEW_WITH_DESCRIPTION.REVIEWEE_MANAGER.description.replace(
        '@revieweeName',
        name
      ),
      value: SHARE_REVIEW_WITH_DESCRIPTION.REVIEWEE_MANAGER.value,
      comments: SHARE_REVIEW_WITH_DESCRIPTION.REVIEWEE_MANAGER.subtitle,
      shortDescription:
        SHARE_REVIEW_WITH_DESCRIPTION.REVIEWEE_MANAGER.shortDescription
    },
    {
      title: SHARE_REVIEW_WITH_DESCRIPTION.ANONYMOUS.description,
      value: SHARE_REVIEW_WITH_DESCRIPTION.ANONYMOUS.value,
      comments: SHARE_REVIEW_WITH_DESCRIPTION.ANONYMOUS.subtitle,
      shortDescription: SHARE_REVIEW_WITH_DESCRIPTION.ANONYMOUS.shortDescription
    }
  ];

  if (isSlackTemplate || isAdaptiveCardTemplate) {
    const openToEveryone = visibilityList.find(
      (o) => o.value === SHARE_REVIEW_WITH.OPEN_TO_EVERYONE
    );
    const openlyWithReviewee = visibilityList.find(
      (o) => o.value === SHARE_REVIEW_WITH.OPENLY_WITH_REVIEWEE
    );
    const revieweeOption = visibilityList.find(
      (o) => o.value === SHARE_REVIEW_WITH.REVIEWEE
    );
    const revieweeManagerOption = visibilityList.find(
      (o) => o.value === SHARE_REVIEW_WITH.REVIEWEE_MANAGER
    );
    const anonymous = visibilityList.find(
      (o) => o.value === SHARE_REVIEW_WITH.ANONYMOUS
    );

    let allShareCommentOptions = [];
    const formattedAvailableOptions = [];

    if (isSlackTemplate) {
      allShareCommentOptions = [
        {
          text: {
            type: 'plain_text',
            text: openToEveryone.title
          },
          description: {
            type: 'plain_text',
            text: openToEveryone.comments
          },
          value: '0'
        },
        {
          text: {
            type: 'plain_text',
            text: openlyWithReviewee.title
          },
          description: {
            type: 'plain_text',
            text: openlyWithReviewee.comments
          },
          value: '1'
        },
        {
          text: {
            type: 'plain_text',
            text: revieweeOption.title
          },
          description: {
            type: 'plain_text',
            text: revieweeOption.comments
          },
          value: '2'
        },
        {
          text: {
            type: 'plain_text',
            text: revieweeManagerOption.title
          },
          description: {
            type: 'plain_text',
            text: revieweeManagerOption.comments
          },
          value: '3'
        },
        {
          text: {
            type: 'plain_text',
            text: anonymous.title
          },
          description: {
            type: 'plain_text',
            text: anonymous.comments
          },
          value: '4'
        }
      ];
    }

    if (isAdaptiveCardTemplate) {
      allShareCommentOptions = [
        {
          title: openToEveryone.title,
          value: '0',
          details: openToEveryone.comments
        },
        {
          title: openlyWithReviewee.title,
          value: '1',
          details: openlyWithReviewee.comments
        },
        {
          title: revieweeOption.title,
          value: '2',
          details: revieweeOption.comments
        },
        {
          title: revieweeManagerOption.title,
          value: '3',
          details: revieweeManagerOption.comments
        },
        {
          title: anonymous.title,
          value: '4',
          details: anonymous.comments
        }
      ];
    }

    if (availableVisibilityOptions) {
      if (availableVisibilityOptions[SHARE_REVIEW_WITH.OPEN_TO_EVERYONE]) {
        formattedAvailableOptions.push(allShareCommentOptions[0]);
      }
      if (availableVisibilityOptions[SHARE_REVIEW_WITH.OPENLY_WITH_REVIEWEE]) {
        formattedAvailableOptions.push(allShareCommentOptions[1]);
      }
      if (availableVisibilityOptions[SHARE_REVIEW_WITH.REVIEWEE]) {
        formattedAvailableOptions.push(allShareCommentOptions[2]);
      }
      if (availableVisibilityOptions[SHARE_REVIEW_WITH.REVIEWEE_MANAGER]) {
        formattedAvailableOptions.push(allShareCommentOptions[3]);
      }
      if (availableVisibilityOptions[SHARE_REVIEW_WITH.ANONYMOUS]) {
        formattedAvailableOptions.push(allShareCommentOptions[4]);
      }
      return formattedAvailableOptions;
    }

    return allShareCommentOptions;
  }

  return visibilityList;
};

const USER_STATE = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  PASSIVE: 'Passive',
  ARCHIVED: 'Archived',
  UNASSIGNED: 'Unassigned'
};

const WIZARD_SUMMARIES_RANGE = {
  LAST_MONTH: {
    key: 'lastMonth',
    value: 1
  },
  ALL: {
    key: 'all',
    value: Number.MAX_SAFE_INTEGER
  }
};

const CHART_VIEW = {
  OVERALL: 'Overall',
  OVERALL_AND_CATEGORIES: 'OverallAndCategories'
};

const DEFAULT_ACCOUNT_PERMISSIONS = {
  canLogin: true
};

const DEFAULT_SCHEDULE_TIME = {
  type: 'company_default',
  time: { min: 8, max: 15 }
};

const DEFAULT_COMPANY_VIEW_PERMISSIONS = {};
Object.keys(ACCESS).forEach((key) => {
  const value = ACCESS[key];
  DEFAULT_COMPANY_VIEW_PERMISSIONS[value] = {
    canViewOrganizationPage: true,
    canViewMyTeamTab: true,
    canViewPeoplePage: true
  };
});

const DEFAULT_COMPANY_SCORE_LABELS = [
  {
    min: 0,
    max: 20,
    label: 'Unacceptable',
    icon: '🙁'
  },
  {
    min: 21,
    max: 40,
    label: 'Needs improvement',
    icon: '😕'
  },
  {
    min: 41,
    max: 60,
    label: 'Meets expectations',
    icon: '😀'
  },
  {
    min: 61,
    max: 80,
    label: 'Exceeds expectations',
    icon: '😁'
  },
  {
    min: 81,
    max: 100,
    label: 'Sets a new standard',
    icon: '🤩'
  }
];

const DEFAULT_DATE_FILTER_OPTIONS = [
  {
    id: DATE_RANGE_FILTERS.LAST_MONTH.key,
    label: DATE_RANGE_FILTERS.LAST_MONTH.label,
    days: DATE_RANGE_FILTERS.LAST_MONTH.days
  },
  {
    id: DATE_RANGE_FILTERS.THREE_MONTHS.key,
    label: DATE_RANGE_FILTERS.THREE_MONTHS.label,
    days: DATE_RANGE_FILTERS.THREE_MONTHS.days
  },
  {
    id: DATE_RANGE_FILTERS.SIX_MONTHS.key,
    label: DATE_RANGE_FILTERS.SIX_MONTHS.label,
    days: DATE_RANGE_FILTERS.SIX_MONTHS.days
  },
  {
    id: DATE_RANGE_FILTERS.ONE_YEAR.key,
    label: DATE_RANGE_FILTERS.ONE_YEAR.label,
    days: DATE_RANGE_FILTERS.ONE_YEAR.days
  }
];

const COMPANY_REVIEW_VISIBILITY_OPTIONS = {
  OPEN_TO_EVERYONE: true,
  OPENLY_WITH_REVIEWEE: true,
  WITH_REVIEWEE: true,
  WITH_REVIEWEE_MANAGER: true,
  ANONYMOUS: true
};

const DEFAULT_COMPANY_REVIEW_VISIBILITY_OPTION = 'OPENLY_WITH_REVIEWEE';

const CATEGORIES_VIEW = {
  CATEGORIES_BUNDLED: 'CATEGORIES_BUNDLED',
  CATEGORIES_NOT_BUNDLED: 'CATEGORIES_NOT_BUNDLED'
};

const GOAL_FILTERS = {
  SEARCH: {
    LIMITED: 'limited',
    COMPLETE: 'complete'
  }
};

const DEFAULT_GOAL_STATUSES = {
  DRAFT: 'Draft',
  NOT_STARTED: 'Not Started', // receive goal updates
  ON_HOLD: 'On hold', // receive goal updates
  ON_TRACK: 'On track', // receive goal updates
  OFF_TRACK: 'Off track', // receive goal updates
  COMPLETE: 'Complete',
  ARCHIVED: 'Archived' // deleted goal
};

const GOAL_VISIBILITY = {
  DEFAULT: 'Default',
  RESTRICTED: 'Restricted',
  PRIVATE: 'Private'
};

const getGoalStatusKeyByValue = (goalValue) => {
  let goalKey;
  Object.keys(DEFAULT_GOAL_STATUSES).forEach((key) => {
    if (DEFAULT_GOAL_STATUSES[key] === goalValue) {
      goalKey = key;
    }
  });
  return goalKey;
};

const getGoalStatusValueByKey = (goalKey, companyid) => {
  if (
    companyid === 'dbb0ab80-b5fa-4ac0-84a3-e53ae558e44c' // Tether
    && DEFAULT_GOAL_STATUSES[goalKey] === DEFAULT_GOAL_STATUSES.ON_TRACK
  ) {
    return 'In Progress';
  }

  return DEFAULT_GOAL_STATUSES[goalKey];
};

const GOALS = {
  LEVELS: {
    ALL: 'All',
    INDIVIDUAL: 'Individual',
    TEAM: 'Team',
    COMPANY: 'Company'
  },
  TYPES: {
    BINARY: 'Binary',
    DOLLAR: 'Dollar',
    NUMBER: 'Number',
    PERCENT: 'Percent'
  },
  STATUS: DEFAULT_GOAL_STATUSES,
  FREQUENCY: {
    WEEKLY: {
      value: 'Weekly',
      label: 'Every week',
      textForm: 'in the last week',
      seconds: 604800
    },
    EVERY_10_DAYS: {
      value: '10 days',
      label: 'Every 10 days',
      textForm: 'in the last 10 days',
      seconds: 864000
    },
    BIMONTHLY: {
      value: '2 weeks',
      label: 'Every 2 weeks',
      textForm: 'in the last 2 weeks',
      seconds: 1209600
    },
    EVERY_3_WEEKS: {
      value: '3 weeks',
      label: 'Every 3 weeks',
      textForm: 'in the last 3 weeks',
      seconds: 1814400
    },
    MONTHLY: {
      value: 'Monthly',
      label: 'Every month',
      textForm: 'in the last month',
      seconds: 2592000 // 30 days
    },
    EVERY_3_MONTHS: {
      value: '3 months',
      label: 'Every 3 months',
      textForm: 'in the last 3 months',
      seconds: 7776000 // 90 days
    }
  }
};
// const MS_TEAMS_SERVICE_URL = 'https://smba.trafficmanager.net/amer';  // DEPRECATED

const SCHEDULE_EVENTS_DAYS_IN_ADVANCE = 2;
// const SCHEDULE_EVENTS_DAYS_IN_ADVANCE = 20;

const COMPANY_DEFAULT_RELATIONSHIP_FREQUENCY = 'COMPANY_DEFAULT';

const REVIEW_EVENT_SCHEDULE_TYPE = {
  INITIAL: 'initial',
  RESCHEDULE: 'reschedule'
};

const DEFAULT_PAGE_SIZE = 10;

const PULSE_PARTICIPATION_TYPES = {
  ANSWERED: 'answered',
  NOT_ANSWERED: 'notAnswered'
};

const USER_REVIEW_NOTIFICATIONS = {
  NEVER: 'Never',
  REVIEWS_WITH_COMMENTS: 'Reviews with comments'
};

const USER_SENTIMENT_NOTIFICATIONS = {
  NONE: 'none',
  NEGATIVE: 'negative',
  POSITIVE: 'positive',
  ALL: 'all'
};

const ACCOUNT_NOTIFICATION_STATES = {
  OFF: 'off',
  WORKSTORY: 'workstory',
  ALL: 'all'
};

const DEFAULT_ACCOUNT_NOTIFICATIONS = {
  basicViewFeedback: ACCOUNT_NOTIFICATION_STATES.ALL,
  managerViewTeamFeedback: ACCOUNT_NOTIFICATION_STATES.WORKSTORY,
  managerViewPositiveFeedback: ACCOUNT_NOTIFICATION_STATES.OFF,
  managerViewNegativeFeedback: ACCOUNT_NOTIFICATION_STATES.ALL,
  adminViewOrganization: ACCOUNT_NOTIFICATION_STATES.OFF,
  adminViewPositiveOrganization: ACCOUNT_NOTIFICATION_STATES.OFF,
  adminViewNegativeOrganization: ACCOUNT_NOTIFICATION_STATES.OFF
};

const DEFAULT_ACCOUNT_SETTINGS = {
  visibleTreeDepth: 2,
  isArchived: false,
  defaultTemplateId: null
};

const ONBOARDING_STATUS = {
  PENDING: 'pending',
  DONE: 'done'
};

const DEFAULT_ONBOARDING_FOR_BUILDER = {
  status: ONBOARDING_STATUS.PENDING,
  setupCompany: ONBOARDING_STATUS.DONE,
  requestFeedbackFromTeamMember: ONBOARDING_STATUS.PENDING,
  adjustReviewRelationships: ONBOARDING_STATUS.PENDING,
  inviteTeamMembers: ONBOARDING_STATUS.PENDING
};

const DEFAULT_ONBOARDING_FOR_ROOT = {
  status: ONBOARDING_STATUS.PENDING,
  setupCompany: ONBOARDING_STATUS.DONE,
  requestFeedbackFromTeamMember: ONBOARDING_STATUS.PENDING,
  adjustReviewRelationships: ONBOARDING_STATUS.PENDING,
  inviteTeamMembers: ONBOARDING_STATUS.PENDING
};

const DEFAULT_ONBOARDING_BY_ACCESS = {
  [ACCESS.BASIC]: {
    status: ONBOARDING_STATUS.PENDING,
    setupCompany: ONBOARDING_STATUS.DONE,
    requestFeedbackFromTeamMember: ONBOARDING_STATUS.PENDING,
    adjustReviewRelationships: ONBOARDING_STATUS.DONE,
    inviteTeamMembers: ONBOARDING_STATUS.DONE
  },
  [ACCESS.MANAGER]: {
    status: ONBOARDING_STATUS.PENDING,
    setupCompany: ONBOARDING_STATUS.DONE,
    requestFeedbackFromTeamMember: ONBOARDING_STATUS.PENDING,
    adjustReviewRelationships: ONBOARDING_STATUS.PENDING,
    inviteTeamMembers: ONBOARDING_STATUS.PENDING
  },
  [ACCESS.ADMIN]: {
    status: ONBOARDING_STATUS.PENDING,
    setupCompany: ONBOARDING_STATUS.DONE,
    requestFeedbackFromTeamMember: ONBOARDING_STATUS.PENDING,
    adjustReviewRelationships: ONBOARDING_STATUS.PENDING,
    inviteTeamMembers: ONBOARDING_STATUS.PENDING
  }
};

const IM_NOT_SURE = "I'm not sure";
const SKIP_QUESTION = 'Skip question';
const QUESTION_SKIPPED = 'Question skipped';
const REVIEW_ANSWER_LABELS = {
  FREE_RESPONSE: 'Free response',
  NOT_APPLICABLE: 'Not applicable'
};

const COMMENT_TYPE = {
  REVIEW: 'review',
  FEEDBACK: 'feedback'
};

// MS Teams specific error messages
const MS_TEAMS_ERRORS = {
  BOT_BLOCKED_BY_USER: 'ConversationBlockedByUser',
  BOT_CONVERSATION_NOT_FOUND: 'ConversationNotFound',
  CONNECTION_ERROR: 'ConnectionError'
};

// workstory app labels for MS Teams errors that occur
// these are NOT MS Teams response error codes
const MS_TEAMS_ERRORS_INFO = {
  DISCONNECTED: 'Disconnected',
  TIMEOUT: 'Timeout'
};

const INTERNAL_ENDPOINT_TYPES = {
  AI_SUMMARY_FEEDBACK: 'ai-summary-feedback'
};

const BE_ON_LOOKOUT_MSG = 'Be on the lookout for the next one!';

const USER_CANNOT_STAY_LOGGED_IN = "User doesn't have permission to stay logged in";

const OPEN_AI_MODELS = {
  GPT_3_5_TURBO: 'gpt-3.5-turbo-1106',
  TEXT_DAVINCI_003: 'text-davinci-003',
  GPT_4: 'gpt-4',
  GPT_4_O_MINI: 'gpt-4o-mini'
};

const RELATIONSHIP_OPERATIONS = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
  UPDATE: 'UPDATE',
  NONE: 'NONE'
};

const REPORT_TEMPLATE_TYPES = {
  FEEDBACK_TEMPLATE: 'FEEDBACK_TEMPLATE',
  SUMMARY_TEMPLATE: 'SUMMARY_TEMPLATE',
  CATEGORY_TEMPLATE: 'CATEGORY_TEMPLATE',
  GOAL_TEMPLATE: 'GOAL_TEMPLATE'
};

const REPORT_TEMPLATE_TYPES_LABEL = {
  FEEDBACK_TEMPLATE: 'Feedback',
  SUMMARY_TEMPLATE: 'Summary',
  CATEGORY_TEMPLATE: 'Category',
  GOAL_TEMPLATE: 'Goal'
};

const SENTIMENT_RANGE = [
  'very negative',
  'somewhat negative',
  'neutral',
  'somewhat positive',
  'very positive'
];

const SENTIMENT_TYPES = {
  NEUTRAL: 'neutral',
  NEGATIVE: 'negative',
  POSITIVE: 'positive'
};
const ANONYMOUS_REVIEW = {
  REVIEWER: 'Hidden',
  NAME: 'Anonymous',
  EMAIL: 'anonymous@workstory.com'
};

const APP_SIZES = {
  PHONE: 'phone',
  TABLET: 'tablet',
  MINI: 'mini',
  FULL: 'full'
};

const MOBILE_SIZES = {
  MINI: 'mini',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};

const REPORT_GENERATION_TYPE = {
  AI: 'ai',
  TRADITIONAL: 'traditional'
};

const SIDEBAR_PAGES = {
  HOME: 'home',
  INBOX: {
    TASKS: 'tasks',
    NOTIFICATIONS: 'notifications',
    REVIEWS_DUE: 'reviews-due',
    PULSE_DUE: 'pulse-due'
  },
  DASHBOARDS: {
    MY_DASHBOARD: 'my-dashboard',
    TEAM_DASHBOARD: 'team-dashboard'
  },
  TRACKING: {
    GOALS: 'goals',
    QUESTIONS: 'questions'
  },
  PEOPLE: {
    ALL_PEOPLE: 'all-people'
  },
  PROFILE: {
    MY_SETTINGS: 'my-settings',
    MY_NOTIFICATIONS: 'my-notifications'
  },
  ORGANIZATION: {
    ORGANIZATION_CHART: 'organization-chart',
    ORGANIZATION_QUESTIONS: 'organization-questions',
    ORGANIZATION_SETTINGS: 'organization-settings',
    ORGANIZATION_EVENTS: 'organization-events'
  }
};

const SCHEDULING_STATUS = {
  IDLE: 'idle',
  IN_PROGRESS: 'in-progress'
};

const ENABLED_STATUS = {
  ENABLED: 'enabled',
  DISABLED: 'disabled'
};

const NOTIFICATION_TYPES = {
  RECEIVED_FEEDBACK: 'RECEIVED_FEEDBACK',
  RECEIVED_REVIEW: 'RECEIVED_REVIEW',
  SENTIMENT_ALERT: 'SENTIMENT_ALERT',
  PARTICIPATION_ALERT: 'PARTICIPATION_ALERT',
  REVIEW_REQUEST: 'REVIEW_REQUEST',
  REQUESTED_FEEDBACK: 'REQUESTED_FEEDBACK',
  BULK_REPORTS_CREATED: 'BULK_REPORTS_CREATED'
};

const TASK_TYPES = {
  REVIEW_REQUESTS: 'review-requests',
  REVIEW_DIRECT_REPORTS: 'review-direct-reports',
  ADD_REVIEW_RELATIONSHIPS: 'add-review-relationships',
  INACTIVE_DIRECT_REPORTS: 'inactive-direct-reports',
  REPORT_CREATED: 'report-created',
  REPORT_SHARED: 'report-shared',
  UPDATE_GOAL: 'update-goal',
  OPEN_PULSE: 'open-pulse',
  ONBOARDING_COMPLETE_FIRST_REVIEW: 'onboarding-complete-first-review',
  ONBOARDING_ENABLE_REVIEWS: 'onboarding-enable-reviews',
  ONBOARDING_REQUEST_FEEDBACK_FROM_TEAM_MEMBER:
    'onboarding-request-feedback-from-team-member',
  ONBOARDING_ADJUST_REVIEW_RELATIONSHIPS:
    'onboarding-adjust-review-relationships',
  ONBOARDING_INVITE_TEAM_MEMBERS: 'onboarding-invite-team-members',
  FINISH_ONBOARDING: 'finish-onboarding'
};

const TASK_TOOLTIP_LABELS = {
  REVIEW_REQUESTS:
    'Catching up on your pending reviews will complete this task',
  REVIEW_DIRECT_REPORTS:
    'Provide feedback or complete a review to check off this task',
  ADD_REVIEW_RELATIONSHIPS:
    'Complete this task by assigning review rules to this person',
  REPORT_CREATED: 'This task will clear once the review is finalized',
  UPDATE_GOAL: 'Provide an update for this goal to complete this task',
  OPEN_PULSE:
    'Catching up on your pending pulse reviews will complete this task',
  REPORT_SHARED: 'Report manager can finalize this report',
  INACTIVE_DIRECT_REPORTS: "Complete this task by updating this member's status"
};

const INCLUDE_SCORES_OPTIONS = {
  YES: 'yes',
  NO: 'no'
};

const PROMPT_TYPES = {
  FEEDBACK_SUGGESTION: 'feedbackSuggestion',
  SUMMARY_SUGGESTION: 'summarySuggestion'
};

const USER_ERRORS = {
  UNAVAILABLE_ACCOUNT: 'This account is not available'
};

const REPORT_PROMISE_TYPES = {
  FEEDBACK_FIRST_STEP: 'feedback-first-step',
  FEEDBACK_SECOND_STEP: 'feedback-second-step',
  FEEDBACK_SINGLE: 'feedback-single',
  CATEGORIES_FIRST_STEP: 'categories-first-step',
  CATEGORIES_SECOND_STEP: 'categories-second-step',
  CATEGORIES_SINGLE: 'categories-single',
  GOALS_FIRST_STEP: 'goals-first-step',
  GOALS_SECOND_STEP: 'goals-second-step',
  GOALS_SINGLE: 'goals-single',
  SUMMARY_SINGLE: 'summary-single'
};

const DEFAULT_REVIEW_SENTIMENT = {
  score: null,
  range: null,
  reason: null,
  queryId: null
};

const PERFORMANCE_BUILDER_BUILDER_STEPS = {
  INFO: 'info',
  TEMPLATE: 'template',
  REVIEWS: 'reviews',
  SUMMARY: 'summary'
};

const DEFAULT_COMPANY_TEMPLATES = {
  MANAGER_SUMMARY_TEMPLATE: {
    name: 'Manager Summary Template',
    content:
      '<h1>Performance</h1><p><br></p><ul><li><strong>Based on competency review, what are the employee\'s key strengths and how have they positively impacted the team/organization?</strong></li></ul><p><br></p><p><br></p><ul><li><strong>Similarly, which competencies could use the most focus moving forward?</strong></li></ul><p><br></p><p><br></p><ul><li><strong>In your opinion, in which areas has the employee shown the most improvement since their last review?</strong></li></ul><p><br></p><p><br></p><ul><li><strong>What were the most significant accomplishments of the employee during the review period?</strong></li></ul><h1><br></h1><h1><br></h1><h1>Goals</h1><p><br></p><p><strong style="background-color: transparent;">What professional development goals should the employee strive towards over the next 3, 6, 12 months?</strong></p><p><br></p><p><strong style="background-color: transparent;">SMART Goal 1:</strong></p><p><br></p><p><br></p><p><strong style="background-color: transparent;">SMART Goal 2:</strong></p><p><br></p><p><br></p><p><strong style="background-color: transparent;">SMART Goal 3:</strong></p><p><br></p><h1><br></h1><h1>Development Plan</h1><p>Creating a development plan is an essential part of the performance review in that it bridges the gap between reflection and action. It enables us to reach the ultimate goal of performance reviews - helping our team members grow. Please craft an actionable development plan to help the employee improve their performance and to provide them with opportunities to reach the stated goals.</p>'
  },
  EMPLOYEE_SUMMARY_TEMPLATE: {
    name: 'Employee Summary Template',
    content:
      '<p><strong>Self-Assessment Summary:</strong></p><p>Briefly summarize your overall performance during the review period. What are the key strengths and areas for improvement you\'ve identified?</p><p><br></p><p><br></p><p><br></p><p><strong>Competency Analysis:</strong></p><p>Review each competency area that was evaluated during the performance review. How do you feel about your performance in each of these areas?</p><p><br></p><p><br></p><p><br></p><p><strong>Score Reflection:</strong></p><p>Take a closer look at the scores you received for each competency. Do you agree with the ratings? Why or why not?</p><p><br></p><p><br></p><p><br></p><p><strong>Areas for Improvement:</strong></p><p>Identify specific areas where you believe you can improve and enhance your performance. How do you plan to address these areas of improvement?</p><p><br></p><p><br></p><p><br></p><p><strong>Career Goals:</strong></p><p>Reflect on your long-term career goals. <span style="background-color: transparent;">What professional development goals should you strive towards over the next 3, 6, 12 months?</span></p><p><br></p><p><strong style="background-color: transparent;">SMART Goal 1:</strong></p><p><br></p><p><br></p><p><strong style="background-color: transparent;">SMART Goal 2:</strong></p><p><br></p><p><br></p><p><strong style="background-color: transparent;">SMART Goal 3:</strong></p><p><br></p><p><br></p><p><strong>Feedback and Support:</strong></p><p>Is there any additional feedback or support you need from your manager or the organization to excel in your role or achieve your career goals?</p><p><br></p><p><br></p><p><br></p><p><strong>Goal Setting for the Next Review Period:</strong></p><p>What are your key performance goals for the upcoming review period? How do you plan to measure your progress towards these goals?</p><p><br></p><p><br></p><p><br></p><p><strong>Feedback on the Review Process:</strong></p><p>Provide any feedback or suggestions you have for improving the performance review process, making it more effective, fair, or transparent.</p>'
  }
};

const DEFAULT_COMPANY_JOBS = {
  bulkReports: SCHEDULING_STATUS.IDLE
};

// this is imported by tailwind.config.js and added to it's color palette through the safelist
const COLORS = {
  white: '#ffffff',
  black: '#000000',
  // state colors
  'state-disabled': '#cecece',
  // default shades (dark blue)
  'primary-default': '#1c2434',
  'secondary-default': '#5c79fb',
  // green shades
  'primary-green': '#004533',
  'secondary-green': '#007a5a',
  'tertiary-green': '#80ea6c',
  // red shades
  'primary-red': '#87161e',
  'secondary-red': '#f24444',
  // orange shades
  'primary-orange': '#994800',
  'secondary-orange': '#f6931e',
  // blue shades
  'primary-blue': '#003a88',
  'secondary-blue': '#2f80ed',
  'tertiary-blue': '#a7e7ff',
  // purple shades
  'primary-purple': '#39006e',
  'secondary-purple': '#9b51e0',
  // gray shades
  'primary-gray': '#4f4f4f',
  'secondary-gray': '#828282',
  'tertiary-gray': '#dbdbdb',
  // black shades
  'primary-black': '#000000',
  'secondary-black': '#4f4f4f',
  'tertiary-black': '#333333',
  // shades without presets from now on
  // yellow shades
  'primary-yellow': '#ffea7e',
  'secondary-yellow': '#ffe45c',
  // purplish shades
  'primary-purplish': '#5b7fff'
};

const COLOR_PRESETS = {
  default: {
    id: 'default',
    label: 'Default',
    primary: COLORS['primary-default'],
    secondary: COLORS['secondary-default']
  },
  green: {
    id: 'green',
    label: 'Green',
    primary: COLORS['primary-green'],
    secondary: COLORS['secondary-green']
  },
  red: {
    id: 'red',
    label: 'Red',
    primary: COLORS['primary-red'],
    secondary: COLORS['secondary-red']
  },
  orange: {
    id: 'orange',
    label: 'Orange',
    primary: COLORS['primary-orange'],
    secondary: COLORS['secondary-orange']
  },
  blue: {
    id: 'blue',
    label: 'Blue',
    primary: COLORS['primary-blue'],
    secondary: COLORS['secondary-blue']
  },
  purple: {
    id: 'purple',
    label: 'Purple',
    primary: COLORS['primary-purple'],
    secondary: COLORS['secondary-purple']
  },
  gray: {
    id: 'gray',
    label: 'Gray',
    primary: COLORS['primary-gray'],
    secondary: COLORS['secondary-gray']
  },
  black: {
    id: 'black',
    label: 'Black',
    primary: COLORS['primary-black'],
    secondary: COLORS['secondary-black']
  }
};

const DEFAULT_COMPANY_STYLING = {
  logoUrl: null,
  colorPresetId: Object.keys(COLOR_PRESETS).at(0)
};

const HELLO_WORKSTORY_EMAIL = 'hello@workstory.team';

const DEFAULT_BUILDER_QUESTION = {
  id: '59f98e4e-7f6d-4430-a9b5-173432483693',
  status: 'Active',
  question:
    'How would you describe their ability to communicate clearly with others on the team?',
  self: 'How would you describe your ability to communicate clearly with others on the team?'
};

const DEFAULT_QUESTION = {
  id: '54d56ddc-b43e-44b5-845e-925acf94daab',
  status: 'Active',
  question:
    "How would you describe @name's ability to communicate clearly with others on the team?",
  self: 'How would you describe your ability to communicate clearly with others on the team?',
  answers: {
    type: 'Custom Labels',
    custom: [
      {
        id: '4593ce01-685e-45f0-bc21-b491b2a7909d',
        score: 3.3,
        value: 'Below expectations'
      },
      {
        id: 'cff7861b-f488-47b9-9d10-0d1acca6ba9a',
        score: 6.7,
        value: 'Meets expectations'
      },
      {
        id: '952a7c88-4a8e-4383-b0e8-85b2893f78b2',
        score: 10,
        value: 'Exceeds expectations'
      }
    ]
  },
  headers: { left: 'Below expectations', right: 'Exceeds expectations' },
  recurring: true
};

const DEFAULT_CATEGORY = {
  id: '42e18a67-4c4c-4783-bc16-5a1642c11623',
  status: 'Active',
  questions: [DEFAULT_QUESTION.id],
  label: 'Default Category'
};

const DEFAULT_ROLE = {
  id: 'f0bfcb45-87a5-4e67-8d4a-87fb8d3be172',
  status: 'Active',
  categories: [DEFAULT_CATEGORY.id],
  label: 'Default Role',
  key: 'Default Role',
  builderQuestionIds: [DEFAULT_BUILDER_QUESTION.id]
};

const DEFAULT_CYCLE = {
  id: '6518234e-7425-48bd-9b13-45625561fbdf',
  label: 'Default Cycle',
  createdDate: '2020-01-01T00:00:00.000Z'
};

const MANAGE_ACCOUNTS_MAX_LENGTH = 200;

const APP_MODES = {
  WORKSTORY: 'workstory',
  BUILDER: 'builder'
};

const EMPTY_INDEX_RESULT = {
  success: true,
  data: [],
  page: {
    number: 1,
    size: 0,
    totalItems: 0,
    totalPages: 1
  }
};

const TEAM_REPORT_TYPES = {
  SELF_EVALUATION: 'selfEvaluation',
  PERFORMANCE_REVIEW: 'performanceReview'
};

const TEAM_REPORT_SCORES = {
  YES: 'yes',
  NO: 'no'
};

const ACCOUNT_RESOURCE_TYPES = {
  PDF: 'pdf'
};

const DEFAULT_COMPANY_BUILDER = {
  cycles: [],
  builderQuestions: []
};

const GET_ACCOUNT_SPEC_OPS = {
  BELOW_ACCOUNTID: 'below-accountId',
  AROUND_ACCOUNTID: 'around-accountId',
  IN_MANAGE_ACCOUNTS_OF_ACCOUNTID: 'in-manage-accounts-of-accountId'
};

// SYSTEM errors are returned by failed checks or exceptions caught on the upload flow
// STRUCTURE errors are validation errors returned if the spreadsheet structure is invalid (ie. missing columns)
// TREE errors are validation errors returned if the tree structure is invalid
// USER errors are validation errors returned if the user data is invalid
const UPLOAD_USERS_ERROR_TYPES = {
  USER: 'user',
  TREE: 'tree',
  SYSTEM: 'system',
  STRUCTURE: 'structure'
};

const DEFAULT_UPLOAD_USERS_COLUMNS = [
  'id',
  'Email',
  'First Name',
  'Last Name',
  'Title',
  'Manager',
  'Access',
  'ImageUrl',
  'Roles',
  'Status',
  'Start Date'
];

const UNIDENTIFIED_TRACE_IDS = {
  USER: 'Unidentified User',
  GOAL: 'Unidentified Goal'
};

const UPLOAD_GOALS_ERROR_TYPES = {
  SYSTEM: 'system',
  STRUCTURE: 'structure',
  GOAL: 'goal'
};

const UPLOAD_GOALS_NO_VALUE_TYPES = {
  CATEGORY: 'no category',
  PARENT_GOAL: 'no parent goal'
};

const DEFAULT_UPLOAD_GOALS_COLUMNS = [
  'Title',
  'Description',
  'Parent Goal',
  'Goal Type',
  'Goal Measurement',
  'Goal Progress',
  'Status',
  'Update Frequency',
  'Assignee',
  'Performance Category',
  'Deadline'
];

const UPLOAD_FILES_MIME_TYPES = {
  CSV: 'text/csv',
  XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
};

const DEFAULT_ALL_TEAM_MEMBERS_GROUPS_ID = 'allTeamMembers';

const DEFAULT_COMPANY_EVENTS = {
  schedulingStatus: SCHEDULING_STATUS.IDLE,
  reviews: ENABLED_STATUS.ENABLED,
  goals: ENABLED_STATUS.DISABLED,
  pulse: ENABLED_STATUS.DISABLED
};

const INACTIVE_COMPANY_EVENTS = {
  schedulingStatus: SCHEDULING_STATUS.IDLE,
  reviews: ENABLED_STATUS.DISABLED,
  goals: ENABLED_STATUS.DISABLED,
  pulse: ENABLED_STATUS.DISABLED
};

const DEFAULT_REQUIRE_COMMENTS_ID = 3;

const DEFAULT_COMPANY_SETTINGS = {
  scoreSystem: SCORE_SYSTEM.AVERAGE,
  requireComments: DEFAULT_REQUIRE_COMMENTS_ID, // option id from 'requireCommentsOptions'
  contentEvents: false,
  directReviewPermissions: DIRECT_REVIEW_PERMISSIONS.PER_REVIEW_RELATIONSHIPS,
  builderDirectReviewPermissions: DIRECT_REVIEW_PERMISSIONS.OPEN,
  reviewVisibilityOptions: COMPANY_REVIEW_VISIBILITY_OPTIONS,
  reviewVisibilityDefaultOption: DEFAULT_COMPANY_REVIEW_VISIBILITY_OPTION,
  viewPermissions: DEFAULT_COMPANY_VIEW_PERMISSIONS,
  viewUserProfile: VIEW_USER_PROFILE_PERMISSIONS.OPEN,
  scoreLabels: DEFAULT_COMPANY_SCORE_LABELS,
  viewScores: VIEW_SCORES_PERMISSIONS.ALL,
  defaultDateFilter: DATE_RANGE_FILTERS.THREE_MONTHS.label
};

const BUILDER_COMMON_ERRORS = {
  REVIEW_COMPLETED: 'This Performance Review is already completed!'
};

const REPORT_ERRORS = {
  REPORT_NOT_AVAILABLE: 'This report is not available anymore',
  NOTES_NOT_AVAILABLE: 'Notes for this report are not available anymore',
  REPORT_NOT_FOUND: 'Report not found'
};

const FEEDBACK_TYPE = {
  GENERAL_FEEDBACK: 'General Feedback',
  CATEGORY_FEEDBACK: 'Category Feedback'
};

const SPECIAL_CHARACTERS = /[\\?%*:|"<>/]/g;

const sanitizeFilename = (input) => input
  .normalize('NFD') // Normalize Unicode (e.g., é → e + ́)
  .replace(/[\u0300-\u036f]/g, '') // Remove accent marks
  .replace(/ /g, '_') // Replace spaces with underscores
  .replace(SPECIAL_CHARACTERS, '-') // Replace known special characters with dashes
  .replace(/[^a-zA-Z0-9_\-.]/g, '-') // Replace any remaining unsafe characters
  .replace(/[-_]{2,}/g, '-') // Collapse multiple dashes/underscores
  .replace(/^[-_]+|[-_]+$/g, ''); // Trim dashes/underscores from start/end

export default {
  WORKSTORY_LOGO_WHITE_PATH,
  WORKSTORY_LOGO_BLACK_PATH,
  COMPANY_IMAGES_PATH,
  COMPANY_LOGOS_PATH,
  REVIEW_ANSWER_LABELS,
  SCHEDULE_EVENTS_DAYS_IN_ADVANCE,
  CATEGORIES_VIEW,
  ACCESS,
  PUBLIC_BUCKET_URL,
  PUBLIC_PROFILE_IMAGES_URL,
  EMAIL_FREQUENCY,
  REVIEW_ANSWER_TYPE,
  REVIEW_STATUS,
  SHOW_INTRO,
  SHOW_INTRO_DEFAULT_SETTING,
  SHOW_INTRO_DEFAULT_SETTING_ADMIN,
  SHOW_INTRO_DEFAULT_SETTING_INVITED_USER,
  SLACK_REDIRECT_URI,
  COMMUNICATION_TYPES,
  LOGIN_TYPES,
  DATE_FILTERS,
  REPORT_SHARE_PERMISSIONS,
  REPORT_TYPE,
  REPORT_NOTE_TYPES,
  REVIEW_SCHEDULING_TIME,
  BILLING_PLANS,
  BILLING_FREQUENCY,
  FEEDBACK_VISIBLE,
  FEEDBACK_TYPE,
  INTERACTION_SOURCE,
  EVENT_TYPES,
  AFTER_REVIEW_TYPE,
  BLOG,
  TASK_EVENTS,
  EDIT_MODES,
  ROLES,
  SCORE_SYSTEM,
  DEFAULT_TIMEZONE_OFFSET,
  DEFAULT_TIMEZONE,
  SCHEDULE_TIMES,
  EMAIL_TYPES,
  DATE_RANGE_FILTERS,
  REVIEW_VISIBILITY,
  COMMENT_VISIBILITY,
  TIMES_IN_SECONDS,
  DIRECT_REVIEW_PERMISSIONS,
  VIEW_USER_PROFILE_PERMISSIONS,
  SHARE_REVIEW_WITH,
  SHARE_REVIEW_WITH_DESCRIPTION,
  DEFAULT_REVIEW_COMMENT_VISIBILITY,
  USER_STATE,
  REVIEW_FILTERS,
  CHART_VIEW,
  DEFAULT_ACCOUNT_PERMISSIONS,
  GOALS,
  GOAL_FILTERS,
  DEFAULT_COMPANY_VIEW_PERMISSIONS,
  DEFAULT_COMPANY_SCORE_LABELS,
  COMPANY_REVIEW_VISIBILITY_OPTIONS,
  DEFAULT_COMPANY_REVIEW_VISIBILITY_OPTION,
  DEFAULT_ACCOUNT_SETTINGS,
  DEFAULT_SCHEDULE_TIME,
  // MS_TEAMS_SERVICE_URL,
  COMPANY_DEFAULT_RELATIONSHIP_FREQUENCY,
  REVIEW_EVENT_SCHEDULE_TYPE,
  VIEW_SCORES_PERMISSIONS,
  DEFAULT_PAGE_SIZE,
  PULSE_PARTICIPATION_TYPES,
  USER_REVIEW_NOTIFICATIONS,
  IM_NOT_SURE,
  COMMENT_TYPE,
  MS_TEAMS_ERRORS,
  MS_TEAMS_ERRORS_INFO,
  INTERNAL_ENDPOINT_TYPES,
  BE_ON_LOOKOUT_MSG,
  USER_CANNOT_STAY_LOGGED_IN,
  OPEN_AI_MODELS,
  WIZARD_SUMMARIES_RANGE,
  RELATIONSHIP_OPERATIONS,
  REPORT_TEMPLATE_TYPES,
  REPORT_TEMPLATE_TYPES_LABEL,
  USER_SENTIMENT_NOTIFICATIONS,
  SENTIMENT_TYPES,
  APP_SIZES,
  SIDEBAR_PAGES,
  ANONYMOUS_REVIEW,
  SCHEDULING_STATUS,
  ENABLED_STATUS,
  REPORT_GENERATION_TYPE,
  INCLUDE_SCORES_OPTIONS,
  REPORT_STATUS,
  BUILDER_REPORT_STATUS,
  NOTIFICATION_TYPES,
  TASK_TYPES,
  PROMPT_TYPES,
  USER_ERRORS,
  SENTIMENT_RANGE,
  REPORT_PROMISE_TYPES,
  TASK_TOOLTIP_LABELS,
  EVENT_LABELS,
  ACCOUNT_NOTIFICATION_STATES,
  DEFAULT_ACCOUNT_NOTIFICATIONS,
  ONBOARDING_STATUS,
  DEFAULT_ONBOARDING_FOR_ROOT,
  DEFAULT_ONBOARDING_FOR_BUILDER,
  DEFAULT_ONBOARDING_BY_ACCESS,
  MAX_ITEMS_PER_REQUEST,
  DEFAULT_REVIEW_SENTIMENT,
  getGoalStatusValueByKey,
  getGoalStatusKeyByValue,
  PERFORMANCE_BUILDER_BUILDER_STEPS,
  DEFAULT_COMPANY_TEMPLATES,
  DEFAULT_COMPANY_STYLING,
  DEFAULT_COMPANY_BUILDER,
  COLORS,
  COLOR_PRESETS,
  HELLO_WORKSTORY_EMAIL,
  DEFAULT_BUILDER_QUESTION,
  DEFAULT_QUESTION,
  DEFAULT_CATEGORY,
  DEFAULT_ROLE,
  DEFAULT_CYCLE,
  MANAGE_ACCOUNTS_MAX_LENGTH,
  APP_MODES,
  EMPTY_INDEX_RESULT,
  TEAM_REPORT_TYPES,
  TEAM_REPORT_SCORES,
  ACCOUNT_RESOURCE_TYPES,
  MOBILE_SIZES,
  GET_ACCOUNT_SPEC_OPS,
  UPLOAD_USERS_ERROR_TYPES,
  DEFAULT_UPLOAD_USERS_COLUMNS,
  renderShareCommentsVisibilityOptions,
  UPLOAD_FILES_MIME_TYPES,
  PUBLIC_LH3_PROFILE_IMAGES_URL,
  SKIP_QUESTION,
  QUESTION_SKIPPED,
  UPLOAD_GOALS_ERROR_TYPES,
  DEFAULT_UPLOAD_GOALS_COLUMNS,
  UPLOAD_GOALS_NO_VALUE_TYPES,
  UNIDENTIFIED_TRACE_IDS,
  DEFAULT_ALL_TEAM_MEMBERS_GROUPS_ID,
  DEFAULT_COMPANY_JOBS,
  BUILDER_COMPANY_MODE,
  BUILDER_REVIEW_MODE,
  DEFAULT_COMPANY_EVENTS,
  INACTIVE_COMPANY_EVENTS,
  DEFAULT_COMPANY_SETTINGS,
  DEFAULT_DATE_FILTER_OPTIONS,
  BUILDER_COMMON_ERRORS,
  REPORT_ERRORS,
  GOAL_VISIBILITY,
  BUILDER_REPORT_BATCH_PATH,
  SPECIAL_CHARACTERS,
  sanitizeFilename
};
